import { render, staticRenderFns } from "./KanbanHistoryEventDialog.vue?vue&type=template&id=5a61eca6&scoped=true"
import script from "./KanbanHistoryEventDialog.vue?vue&type=script&lang=js"
export * from "./KanbanHistoryEventDialog.vue?vue&type=script&lang=js"
import style0 from "./KanbanHistoryEventDialog.vue?vue&type=style&index=0&id=5a61eca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a61eca6",
  null
  
)

export default component.exports